<template>
    <div class="relative bg-accent">
        <Container height="none" class="relative overflow-hidden">
            <!-- <div class="z-0 absolute inset-0">
                <Logo class="w-full h-full" style="--logo-color: white" />
            </div> -->
            <div class="z-10 relative bg-linear-to-t from-accent/25 via-20% via-accent/85 to-85% to-accent pt-12 text-white">
                <div class="mx-auto px-4 md:px-6 py-8 max-w-6xl">
                    <div class="md:items-start gap-6 grid md:grid-cols-12">
                        <!-- برند/لوگو -->
                        <div class="flex flex-col items-center gap-3 md:col-span-3">
                            <span class="place-items-center grid bg-zinc-900 shadow rounded-full size-16">
                                <Logo />
                            </span>
                            <div>
                                <div class="font-semibold text-base text-center tracking-tight">{{ t("general.footer.brand_name") }}</div>
                                <div class="text-xs">{{ t("general.footer.brand_subtitle") }}</div>
                            </div>
                        </div>

                        <!-- متن خلاصه برند -->
                        <div class="md:col-span-6 text-sm leading-7">
                            <p>{{ t("general.footer.brand_description_1") }}</p>
                            <p class="mt-1">{{ t("general.footer.brand_description_2") }}</p>
                            <p class="mt-1">{{ t("general.footer.brand_description_3") }}</p>
                            <p class="mt-2 font-semibold">{{ t("general.footer.brand_tagline") }}</p>
                        </div>

                        <!-- لینک‌های کلیدی -->
                        <nav class="md:col-span-3 text-sm">
                            <Typography tag="h5" class="text-white">{{ t("general.footer.useful_links") }}</Typography>
                            <ul class="space-y-2 mt-4 pr-6 list-disc">
                                <li>
                                    <a href="/">{{ t("general.home") }}</a>
                                </li>
                                <li>
                                    <a href="/categories">{{ t("general.categories") }}</a>
                                </li>
                                <li>
                                    <a href="/verify">{{ t("general.verify") }}</a>
                                </li>
                                <li>
                                    <a href="/about">{{ t("general.about.label") }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div class="mx-auto mt-6">
                    <div v-if="social?.length" class="flex flex-col justify-between items-center bg-foreground/25 p-4 rounded-md text-white">
                        <h6>{{ t("general.footer.follow_us") }}</h6>
                        <ul class="gap-4 grid grid-cols-2 mt-4 w-full social-list">
                            <li v-for="({ href, title, icon: name }, key) in social" :key>
                                <NuxtLink :href>
                                    <span>{{ title }}</span>
                                    <Icon :name class="size-5!" />
                                </NuxtLink>
                            </li>
                        </ul>
                    </div>
                    <Separator class="mt-12 bg-accent-foreground" />
                </div>
            </div>
        </Container>
        <Container height="none">
            <!-- نوار پایانی -->
            <div class="flex md:flex-row flex-col-reverse md:justify-between items-center gap-3 py-2 text-white/50 text-xs">
                <p>{{ t("general.footer.copyright", { year: new Date().getFullYear() }) }}</p>
                <div class="flex items-center gap-4">
                    <NuxtLink to="/privacy">{{ t("general.privacy") }}</NuxtLink>
                    <span aria-hidden>•</span>
                    <NuxtLink to="/terms">{{ t("general.terms") }}</NuxtLink>
                </div>
            </div>
        </Container>
    </div>
</template>

<script lang="ts" setup>
import { Separator } from "~/components/ui/separator";

const { t } = useI18n();

const social = [
    // { href: "#", title: "telegram", icon: "ic:round-telegram" },
    // { href: "#", title: "instagram", icon: "akar-icons:instagram-fill" },
    // { href: "#", title: "facebook", icon: "akar-icons:facebook-fill" },
    // { href: "#", title: "youtube", icon: "akar-icons:youtube-fill" },
    // { href: "#", title: "twitter", icon: "akar-icons:twitter-fill" },
];
</script>

<style scoped>
@reference 'tailwindcss';

.match-prev-section-bg::after {
    content: "";
    inset: 0 0 50% 0;
    @apply z-0 absolute;
}

.title-bg-effect::before {
    content: "";
    background: var(--color-indigo-700);
    @apply top-0 left-0 -z-5 absolute opacity-20 w-0 h-full transition-all;
}

.group:hover .title-bg-effect::before {
    @apply w-full;
}

.social-list > li > * {
    @apply flex justify-center items-center gap-2 p-2;
}
.social-list > li > *:hover {
    @apply bg-white/10;
}
</style>
